// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/home/ubuntu/code/thanktrip-admin/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAuth0 from '/home/ubuntu/code/thanktrip-admin/src/models/auth.ts';
import ModelGlobal1 from '/home/ubuntu/code/thanktrip-admin/src/models/global.ts';
import ModelSetting2 from '/home/ubuntu/code/thanktrip-admin/src/models/setting.ts';
import ModelModel3 from '/home/ubuntu/code/thanktrip-admin/src/pages/Activity/model.ts';
import ModelModel4 from '/home/ubuntu/code/thanktrip-admin/src/pages/Analytics/model.ts';
import ModelModel5 from '/home/ubuntu/code/thanktrip-admin/src/pages/Area/model.ts';
import ModelModel6 from '/home/ubuntu/code/thanktrip-admin/src/pages/AutomaticQuote/model.ts';
import ModelModel7 from '/home/ubuntu/code/thanktrip-admin/src/pages/Blog/model.ts';
import ModelModel8 from '/home/ubuntu/code/thanktrip-admin/src/pages/Booking/model.ts';
import ModelModel9 from '/home/ubuntu/code/thanktrip-admin/src/pages/ComboOrder/model.ts';
import ModelModel10 from '/home/ubuntu/code/thanktrip-admin/src/pages/Cost/model.ts';
import ModelModel11 from '/home/ubuntu/code/thanktrip-admin/src/pages/CostCategory/model.ts';
import ModelModel12 from '/home/ubuntu/code/thanktrip-admin/src/pages/Customer/model.ts';
import ModelModel13 from '/home/ubuntu/code/thanktrip-admin/src/pages/HotelOrder/model.ts';
import ModelModel14 from '/home/ubuntu/code/thanktrip-admin/src/pages/HotelService/model.ts';
import ModelModel15 from '/home/ubuntu/code/thanktrip-admin/src/pages/Menu/model.ts';
import ModelModel16 from '/home/ubuntu/code/thanktrip-admin/src/pages/Order/model.ts';
import ModelModel17 from '/home/ubuntu/code/thanktrip-admin/src/pages/Partner/model.ts';
import ModelModel18 from '/home/ubuntu/code/thanktrip-admin/src/pages/Place/model.ts';
import ModelModel19 from '/home/ubuntu/code/thanktrip-admin/src/pages/PlaceUtility/model.ts';
import ModelModel20 from '/home/ubuntu/code/thanktrip-admin/src/pages/Policy/model.ts';
import ModelModel21 from '/home/ubuntu/code/thanktrip-admin/src/pages/PrintRequest/model.ts';
import ModelModel22 from '/home/ubuntu/code/thanktrip-admin/src/pages/Receipt/model.ts';
import ModelModel23 from '/home/ubuntu/code/thanktrip-admin/src/pages/Reservation/model.ts';
import ModelModel24 from '/home/ubuntu/code/thanktrip-admin/src/pages/Role/model.ts';
import ModelModel25 from '/home/ubuntu/code/thanktrip-admin/src/pages/Staff/model.ts';
import ModelModel26 from '/home/ubuntu/code/thanktrip-admin/src/pages/Supplier/model.ts';
import ModelModel27 from '/home/ubuntu/code/thanktrip-admin/src/pages/TicketService/model.ts';
import ModelModel28 from '/home/ubuntu/code/thanktrip-admin/src/pages/Tour/model.ts';
import ModelModel29 from '/home/ubuntu/code/thanktrip-admin/src/pages/TourGuide/model.ts';
import ModelModel30 from '/home/ubuntu/code/thanktrip-admin/src/pages/TourSell/model.ts';
import ModelModel31 from '/home/ubuntu/code/thanktrip-admin/src/pages/Trip/model.ts';
import ModelModel32 from '/home/ubuntu/code/thanktrip-admin/src/pages/TripCategory/model.ts';
import ModelModel33 from '/home/ubuntu/code/thanktrip-admin/src/pages/UpgradeRequest/model.ts';
import ModelModel34 from '/home/ubuntu/code/thanktrip-admin/src/pages/User/model.ts';
import ModelModel35 from '/home/ubuntu/code/thanktrip-admin/src/pages/UserActive/model.ts';
import ModelModel36 from '/home/ubuntu/code/thanktrip-admin/src/pages/VehicleService/model.ts';
import ModelModel37 from '/home/ubuntu/code/thanktrip-admin/src/pages/Visa/model.ts';
import ModelModel38 from '/home/ubuntu/code/thanktrip-admin/src/pages/VisaService/model.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'auth', ...ModelAuth0 });
app.model({ namespace: 'global', ...ModelGlobal1 });
app.model({ namespace: 'setting', ...ModelSetting2 });
app.model({ namespace: 'model', ...ModelModel3 });
app.model({ namespace: 'model', ...ModelModel4 });
app.model({ namespace: 'model', ...ModelModel5 });
app.model({ namespace: 'model', ...ModelModel6 });
app.model({ namespace: 'model', ...ModelModel7 });
app.model({ namespace: 'model', ...ModelModel8 });
app.model({ namespace: 'model', ...ModelModel9 });
app.model({ namespace: 'model', ...ModelModel10 });
app.model({ namespace: 'model', ...ModelModel11 });
app.model({ namespace: 'model', ...ModelModel12 });
app.model({ namespace: 'model', ...ModelModel13 });
app.model({ namespace: 'model', ...ModelModel14 });
app.model({ namespace: 'model', ...ModelModel15 });
app.model({ namespace: 'model', ...ModelModel16 });
app.model({ namespace: 'model', ...ModelModel17 });
app.model({ namespace: 'model', ...ModelModel18 });
app.model({ namespace: 'model', ...ModelModel19 });
app.model({ namespace: 'model', ...ModelModel20 });
app.model({ namespace: 'model', ...ModelModel21 });
app.model({ namespace: 'model', ...ModelModel22 });
app.model({ namespace: 'model', ...ModelModel23 });
app.model({ namespace: 'model', ...ModelModel24 });
app.model({ namespace: 'model', ...ModelModel25 });
app.model({ namespace: 'model', ...ModelModel26 });
app.model({ namespace: 'model', ...ModelModel27 });
app.model({ namespace: 'model', ...ModelModel28 });
app.model({ namespace: 'model', ...ModelModel29 });
app.model({ namespace: 'model', ...ModelModel30 });
app.model({ namespace: 'model', ...ModelModel31 });
app.model({ namespace: 'model', ...ModelModel32 });
app.model({ namespace: 'model', ...ModelModel33 });
app.model({ namespace: 'model', ...ModelModel34 });
app.model({ namespace: 'model', ...ModelModel35 });
app.model({ namespace: 'model', ...ModelModel36 });
app.model({ namespace: 'model', ...ModelModel37 });
app.model({ namespace: 'model', ...ModelModel38 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
